export default __webpack_public_path__ + "static/media/team_icon.c43bfbce.svg";